import { LIGHT_RATES, GAS_RATES, POWER_PERIODS } from '@/constants/supplyRates'

/**
 * Tarifas y potencias del formulario de inmueble.
 *
 * Tarifa luz y Tarifa gas son dos selectores independientes, cada uno con su
 * catálogo. P1-P6 pertenecen a la luz: sin tarifa de luz quedan visibles pero
 * deshabilitadas y vacías. Los valores viven en los suministros del inmueble
 * (uno de luz, uno de gas), de donde se leen al editar.
 */
export const powersEnabled = (lightRate) => Boolean(lightRate)

/**
 * Opciones del selector. Un contrato migrado puede traer una tarifa fuera del
 * catálogo ("2.0 A"): se ofrece tal cual para poder conservarla, pero no se
 * puede elegir otra que no esté en el catálogo.
 */
export const rateOptions = (catalog, current = '') => {
  const values = current && !catalog.includes(current) ? [current, ...catalog] : catalog
  return values.map((value) => ({ value, label: value }))
}

export const lightRateOptions = (current = '') => rateOptions(LIGHT_RATES, current)

export const gasRateOptions = (current = '') => rateOptions(GAS_RATES, current)

export const emptyRatesForm = () => ({
  light_rate: '',
  gas_rate: '',
  ...Object.fromEntries(POWER_PERIODS.map((period) => [period, ''])),
})

/** Valores del formulario a partir de los suministros del inmueble (edición). */
export const ratesFromSupplies = (supplies = []) => {
  const light = (supplies || []).find((supply) => supply?.type === 'light')
  const gas = (supplies || []).find((supply) => supply?.type === 'gas')
  const form = emptyRatesForm()
  form.light_rate = light?.rate ?? ''
  form.gas_rate = gas?.rate ?? ''
  for (const period of POWER_PERIODS) {
    const value = light?.[period]
    form[period] = value === null || value === undefined ? '' : String(Number(value))
  }
  return form
}

const toNumber = (value) => {
  const text = String(value ?? '').trim().replace(',', '.')
  if (text === '') return null
  const number = Number(text)
  return Number.isFinite(number) ? number : NaN
}

/** Errores de formato de las potencias (clave de traducción por campo). */
export const validatePowers = (form) => {
  const errors = {}
  if (!powersEnabled(form.light_rate)) return errors
  for (const period of POWER_PERIODS) {
    const number = toNumber(form[period])
    if (Number.isNaN(number) || (number !== null && number < 0)) {
      errors[period] = 'property.estateForm.validation.power'
    }
  }
  return errors
}

/** Campos que se envían a la API. Sin tarifa de luz no viajan potencias. */
export const ratesPayload = (form) => {
  const payload = {
    light_rate: form.light_rate ? String(form.light_rate) : null,
    gas_rate: form.gas_rate ? String(form.gas_rate) : null,
  }
  for (const period of POWER_PERIODS) {
    payload[period] = payload.light_rate ? toNumber(form[period]) : null
  }
  return payload
}
